module.exports = __webpack_public_path__ + "static/media/ico_close_modal.714b5bf9.svg";